import { cardImageSources, type GenericCharacter } from './types'

export const genericConejoPascua: GenericCharacter = {
  id: 'generic-conejo-pascua',
  enabled: true,
  order: 1,
  displayName: 'El Conejo de Pascua',
  icon: '🐰',
  imageSources: cardImageSources('generic-conejo-pascua'),
  previewVideoSrc: '/videos/previews/generic-conejo-pascua.mp4',
}
